import {
  ClientApplicationGetRequestDto,
  ClientApplicationGetResponseDto,
} from '~/store/apis/dtos/applications/application.dto';
import { Application } from '~/models/application/application';
import { AppliedLoanStatus } from '@qred/shared-enums';

export const mapClientApplication = (
  response: ClientApplicationGetResponseDto,
  args: ClientApplicationGetRequestDto
): Application | undefined => {
  const { companies } = response.client;
  const activeCompany = companies.find(
    (client) => client.company_id === args.companyId
  ) ?? { applications: [] };

  if (
    activeCompany.applications === null ||
    activeCompany.applications.length === 0
  ) {
    return undefined;
  }

  const application = activeCompany.applications[0];

  return {
    amount: application.amount,
    applicationDate: application.applic_date,
    loanPurpose: application.loan_purpose,
    applicationId: application.r_application_id,
    contractId: application.r_contract_id,
    signers: application.signers,
    status: application.status as AppliedLoanStatus,
    term: application.term,
  };
};
